<template>
    <div class="p20 power-set" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新增权限</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" size="small" @click="submit" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm"
                v-model="submitForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
        <!-- 权限的设置 start -->
        <ly-power-set :list="powersetList"></ly-power-set>
        <!-- 权限的设置 end -->
    </div>
</template>
<script>
    import AddFormConfig from './add-form'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyRouterButton from '@c/router-button'
    import LyPowerSet from './set'
    export default {
        mixins: [
            AddFormConfig,
            AddRulesConfig
        ],
        components: {
            LySearchForm,
            LyRouterButton,
            LyPowerSet
        },
        data () {
            return {
                loading: false,
                submitLoad: false, // 提交按钮的状态标识
                submitForm: {},
                powersetList: [] // 权限设置列表 
            }
        },
        created () {
            // 设置UUID
            this.submitForm.uuid = this.$utils.createUUID()
            this.queryPowersetList()
        },
        methods: {
            /**
             * 获取权限设置列表 
             * @return {[type]} [description]
             */
            queryPowersetList () {
                this.loading = true
                this.$api.query('api/quanxianlist').then((rs) => {
                    this.powersetList = rs
                    this.loading = false
                }).catch((error) => {
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 数据的提交
             */
            submit () {
                if (this.$refs['searchForm'].validateForm()) {
                    this.submitLoad = true
                    this.submitForm.config = this.powersetList
                    this.$api.create('api/quanxian', this.submitForm).then((rs) => {
                        this.submitLoad = false
                        this.$router.push('/bill/power/list')
                        // 更新UUID
                        this.submitForm.uuid = this.$utils.createUUID()
                    }).catch((error) => {
                        this.submitLoad = false
                        this.$message({
                            message: error,
                            type: 'warning'
                        })
                    })
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>
<style>
    
    .power-set .el-collapse-item{
        position: relative;
        background-color: #08a;
    }
     .power-set .el-collapse-item .powerSwitch{
        position: absolute;
        top:10px;
        right: 10px;
     }
    .power-set table {
        width: 100%;
        padding-bottom: 5px;
        border-bottom: 1px dashed #dfe6ec;
    }
    .power-page-title  {
        font-size: 14px;
        font-weight: bold;
        padding: 10px 0 2px;
    }
</style>